<template>
  <div class="jps-curation">
    <NuxtPage />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  disableDefaultMargin: true,
})
</script>

<style lang="scss" scoped>
</style>
